import { useEffect, useState } from "react";
import PlaySourceContent from "./PlaySourceContent";
import { repeatIsLoop, repeatIsTimes, repeatIsSingle } from "./PlayArea.logic";
import { AreaSource, PlayRepeat } from "type/panel/Panel.type";
import PlayAreaRepeat from "./PlayAreaRepeat";

type Props = {
  areaSource: AreaSource;
  playMapInd: number;
  areaInd: number;
};

const PlayArea = ({ areaSource, playMapInd, areaInd }: Props) => {
  const [playInd, setPlayInd] = useState<number | null>(null);
  const [playActive, setPlayActive] = useState<boolean>(false);
  const [repeatPlayActive, setRepeatPlayActive] = useState<boolean>(false);
  const [repeatCount, setRepeatCount] = useState<number>(0);

  useEffect(() => {
    setPlayActive(true);
    setRepeatPlayActive(true);
  }, [playInd, repeatCount]);

  useEffect(() => {
    if (playInd !== null) {
      if (!playActive && playInd < areaSource.source.length - 1) {
        const nextPlayInd = playInd + 1;
        setPlayInd(nextPlayInd);
      }
    } else {
      setPlayInd(0);
    }
  }, [playActive]);

  const elapseHandle = () => {
    setPlayActive(false);
  };

  const timesCountElapseHandle = () => {
    console.log("timesCountElapseHandle");
    if (playInd !== null) {
      if (playInd < areaSource.source.length - 1) {
        const nextPlayInd = playInd + 1;
        console.log("nextPlayInd", nextPlayInd);
        setPlayInd(nextPlayInd);
        setRepeatPlayActive(false);
      }
    }
  };

  return (
    <>
      {playActive &&
        playInd !== null &&
        repeatIsSingle(areaSource.source[playInd].repeat) && (
          <PlaySourceContent
            contentSource={areaSource.source[playInd]}
            playMapInd={playMapInd}
            areaInd={areaInd}
            onElapse={elapseHandle}
          />
        )}
      {repeatPlayActive &&
        playInd !== null &&
        !repeatIsSingle(areaSource.source[playInd].repeat) && (
          <PlayAreaRepeat
            playMapInd={playMapInd}
            areaInd={areaInd}
            source={areaSource.source[playInd]}
            onTimesCountElapse={timesCountElapseHandle}
          />
        )}
    </>
  );
};

export default PlayArea;
